<template>
  <div class="scene-checkpoint-result">
    <BackButton @back="onBack" />

    <img class="result" :src="resultBackground" @click="onNext" />

    <img class="sprite .hu__hu__" src="/images/game/sprite-7.png" />

    <div class="result-B" v-if="result === 'B'">
      <img class="b" src="/images/game/B-result.png" />
      <img class="back" src="/images/game/cp-back-button.png" @click="onBack" />
      <img class="replay" src="/images/game/cp-replay-button.png" @click="onReplay" />
    </div>
  </div>
</template>

<script>
import BackButton from "../common/BackButton";

export default {
  name: "CheckpointResultScene",
  components: {
    BackButton
  },
  data() {
    return {
      close: false
    };
  },
  computed: {
    result: function() {
      return this.$store.state.game.currentCheckpointResult;
    },
    resultBackground: function() {
      return `/images/game/${this.result}-background.png`;
    }
  },
  created() {
    if (this.result === "B") {
      this.$emit("changeForegroundMusic", "/music/闯关失败音乐.mp3");
    } else {
      this.$emit(
        "changeForegroundMusic",
        "/music/成绩牌（成功）出来背景音乐.mp3"
      );
    }
  },
  mounted() {
    setTimeout(this.next, 4000);
  },
  methods: {
    onAnimation() {},
    onBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    },
    onReplay() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "CheckpointStartScene");
    },
    async onNext() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "CheckpointTaskScene");
    },
    next() {
      this.$emit("changeScene", "CheckpointTaskScene");
    }
  }
};
</script>


<style lang="scss" scoped>
@keyframes backgroundmove {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.scene-checkpoint-result {
  width: 1100px;
  height: 560px;
  position: relative;

  background-image: url("/images/game/result-background.png");
  background-size: cover;

  animation: backgroundmove 2s;

  .sprite {
    position: absolute;
    top: 108px;
    left: 125px;
    width: 361px;
    height: 377px;

    animation: spritemove 1s linear, spritemove 1s linear 3s reverse;
  }

  @keyframes spritemove {
    from {
      left: -361px;
    }

    to {
      left: 125px;
    }
  }

  .result {
    position: absolute;
    top: 50px;
    right: 100px;
    width: 915px;
    height: 474px;

    animation: resultmove 1s linear, resultmove 1s linear 3s reverse;
  }

  @keyframes resultmove {
    from {
      right: -915px;
    }

    to {
      right: 100px;
    }
  }

  .result-B {
    position: absolute;
    top: 220px;
    left: 550px;

    animation: resultmove 1s linear, resultmove 1s linear 3s reverse;

    // text-align: center;

    width: 300px;

    .b {
      width: 170px;
      height: 70px;

      margin-left: 10px;
      margin-bottom: 20px;
    }

    .back {
      width: 130px;
      height: 34px;

      cursor: pointer;

      margin-right: 10px;
    }

    .replay {
      width: 130px;
      height: 34px;

      cursor: pointer;
    }

    .back:hover,
    .replay:hover {
      box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
    }
  }
}
</style>